'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _loadingDots = require('loading-dots');

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _widgetsUtils = require('widgets-utils');

var _constats = require('../utils/constats');

var _style = require('./../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _reviewItem = require('widgets-utils/src/styles/review-item.scss');

var _reviewItem2 = _interopRequireDefault(_reviewItem);

var _recommendationItem = require('widgets-utils/src/styles/recommendation-item.scss');

var _recommendationItem2 = _interopRequireDefault(_recommendationItem);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement(_loadingDots.LoadingDots, { centered: true });

var _ref2 = _react2.default.createElement(
    'span',
    null,
    'Verified by'
);

var DoctifyWfPeerRecommendation = function (_WfAbstractComponent) {
    (0, _inherits3.default)(DoctifyWfPeerRecommendation, _WfAbstractComponent);

    function DoctifyWfPeerRecommendation(props) {
        (0, _classCallCheck3.default)(this, DoctifyWfPeerRecommendation);

        var _this = (0, _possibleConstructorReturn3.default)(this, _WfAbstractComponent.call(this, props));

        _this.animate = _this.animate.bind(_this);
        _this.getTabsNav = _this.getTabsNav.bind(_this);
        _this.changeTab = _this.changeTab.bind(_this);

        _this.state = {
            loading: false
        };
        return _this;
    }

    DoctifyWfPeerRecommendation.prototype.componentDidMount = function componentDidMount() {
        _widgetsUtils.WfAbstractComponent.prototype.componentDidMount.call(this);
        this.onResize();
        if (window) {
            if (window.addEventListener) {
                window.addEventListener("resize", (0, _debounce2.default)(this.onResize, 100));
            } else {
                window.attachEvent("resize", (0, _debounce2.default)(this.onResize, 100));
            }
        }
    };

    DoctifyWfPeerRecommendation.prototype.componentWillUnmount = function componentWillUnmount() {
        _widgetsUtils.WfAbstractComponent.prototype.componentDidUnmount.call(this);
        if (window) {
            if (window.removeEventListener) {
                window.removeEventListener("resize", (0, _debounce2.default)(this.onResize, 100));
            } else {
                window.detachEvent("resize", (0, _debounce2.default)(this.onResize, 100));
            }
        }
    };

    DoctifyWfPeerRecommendation.prototype.getSlideContent = function getSlideContent(slide) {
        return slide.map(function (review) {
            var dateSource = (0, _moment2.default)(review.timestamp_created);
            var date = dateSource.format("DD/MM/YYYY");
            return _react2.default.createElement(_widgetsUtils.ReviewItem, {
                key: review.id,
                rate: review.aggregate_score,
                content: review.review.body,
                date: date,
                isReviewVerified: review.is_verified,
                contentStyle: { "height": "70px" },
                additionalClass: _style2.default['review-addon']
            });
        });
    };

    DoctifyWfPeerRecommendation.prototype.getTabsNav = function getTabsNav(tabs) {
        var _this2 = this;

        return tabs.map(function (tab) {
            var classes = _style2.default["tabs-item"] + (tab === _this2.props.activeTab ? ' ' + _style2.default["tabs-item_active"] : '');
            return _react2.default.createElement(
                'button',
                {
                    className: classes,
                    onClick: _this2.changeTab,
                    'data-tab': tab
                },
                _constats.tabsElements[tab].title[_this2.props.profileType]
            );
        });
    };

    DoctifyWfPeerRecommendation.prototype.onResize = function onResize() {
        var width = window.innerWidth;
        var reviewsLimit = 2;
        var recommendationsLimit = 1;

        if (this.props.showSpecialistImageInReview) {
            if (width >= 850) {
                reviewsLimit = 6;
            } else if (width >= 600) {
                reviewsLimit = 4;
            }
        } else {
            if (width >= 750) {
                reviewsLimit = 6;
            } else if (width >= 480) {
                reviewsLimit = 4;
            }
        }

        if (width >= 900) {
            recommendationsLimit = 3;
        } else if (width >= 640) {
            recommendationsLimit = 2;
        }

        this.animate(this.props.resize, reviewsLimit, recommendationsLimit, this.props);
    };

    DoctifyWfPeerRecommendation.prototype.animate = function animate(promise) {
        var _this3 = this;

        this.setState((0, _extends3.default)({}, this.state, {
            loading: true
        }));

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        promise.apply(undefined, args).then(function () {
            _this3.setState((0, _extends3.default)({}, _this3.state, {
                loading: false
            }));
        });
    };

    DoctifyWfPeerRecommendation.prototype.changeTab = function changeTab(event) {
        this.animate(this.props.changeTab, event.target.getAttribute('data-tab'), this.props);
    };

    DoctifyWfPeerRecommendation.prototype.render = function render() {
        var props = this.props;

        var ActiveTab = _constats.tabsElements[this.props.activeTab].elem;

        var bodyStyle = props.bodyStyle;
        var showImageInReviews = props.showSpecialistImageInReview || props.showPracticeImageInReview;

        var profileImage = props.practice && props.practice.profileImage || props.specialists && props.specialists[1] && props.specialists[1].profileImage;

        return _react2.default.createElement(
            'div',
            { className: [_style2.default.container, props.showProfileLogo && profileImage && _style2.default['container_with-logo'] || ''].join(" ")
            },
            _react2.default.createElement(
                'div',
                {
                    className: [_style2.default.wrapper, this.state.loading && _style2.default["wrapper_loading"] || '', bodyStyle && bodyStyle.backgroundColor && bodyStyle.backgroundColor === "transparent" && _reviewItem2.default["transparent-body"] + ' ' + _recommendationItem2.default["transparent-body"] || '', showImageInReviews && _style2.default['show-image-in-reviews'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame']].join(" "),
                    style: { backgroundColor: bodyStyle.backgroundColor }
                },
                props.showProfileLogo && profileImage && _react2.default.createElement(
                    'div',
                    { className: _style2.default["wrapper__logo"] },
                    _react2.default.createElement('img', { src: profileImage, alt: '' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _style2.default.tabs },
                    this.getTabsNav(props.tabs, props.activeTab)
                ),
                _react2.default.createElement(
                    'div',
                    { className: _style2.default["pos-r"] },
                    this.state.loading && _ref,
                    _react2.default.createElement(ActiveTab, (0, _extends3.default)({}, props, { onLoading: this.animate }))
                ),
                _react2.default.createElement(
                    'div',
                    { className: _style2.default.footer },
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default["doctify-logo"] },
                        _ref2,
                        _react2.default.createElement(
                            'a',
                            {
                                href: props.href,
                                target: '_blank',
                                rel: 'nofollow noopener'
                            },
                            _react2.default.createElement(_widgetsUtils.DoctifyLogo, { logoSize: _widgetsUtils.DoctifyLogo.LOGO_SIZE_SMALL })
                        )
                    )
                )
            )
        );
    };

    return DoctifyWfPeerRecommendation;
}(_widgetsUtils.WfAbstractComponent);

DoctifyWfPeerRecommendation.displayName = 'DoctifyWfPeerRecommendation';

DoctifyWfPeerRecommendation.defaultProps = {
    tabs: _constats.tabsArray,
    activeTab: _constats.tabsArray[0],
    reviews: [],
    specialists: [],
    recommendations: [],
    offset: 0,
    reviewsLimit: 2,
    recommendationsLimit: 1,
    averageRating: 0,
    wrapperFrame: true
};

exports.default = DoctifyWfPeerRecommendation;